// `numeric: true` → "Level 2" before "Level 10"; `sensitivity: 'base'` → case/accent-insensitive.
// Filter chips and body sort comparator must share this so chip selections land on visually adjacent bands.
export const compareNaturalLabels = (a: string, b: string): number =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
